import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=76f3b8f6&scoped=true&"
import script from "./ProductSection.vue?vue&type=script&lang=js&"
export * from "./ProductSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=76f3b8f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f3b8f6",
  null
  
)

export default component.exports